import { FormattedMessage } from 'react-intl';

import { PageWrapper } from 'modules/layout';

import AddInfoCategoryForm from '../../containers/InfoCategories/AddInfoCategoryForm';

const AddInfoCategoryPage = () => (
    <PageWrapper header={<FormattedMessage id="infoCategory.add.title" />}>
        <AddInfoCategoryForm />
    </PageWrapper>
);

export default AddInfoCategoryPage;
